import { Component, OnInit } from '@angular/core';
import { TransactionResult } from '../../../../core/services/interfaces/transaction-result';
import { IEmployees } from '../Interfaces/IEmployees';
import { EmployeesService } from '../services/employees-service';
import { MatDialog } from '@angular/material/dialog';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { DatePipe } from '@angular/common';
import { RolesService } from '../services/roles-service';
import { Router } from '@angular/router';
import { EmployeesDetailComponent } from './employees-detail/employees-detail.component';
import { IScreens } from '../Interfaces/IScreens';
import { IRoles } from '../Interfaces/IRoles';
declare var jQuery: any;
@Component({
    selector: 'app-employees',
    templateUrl: './employees.component.html'
})
export class EmployeesComponent implements OnInit {
  listData: IEmployees[];
  employee: IEmployees = {
    pkemployee: 0,
    employeename: '',
    username: '',
    workdayid: '',
    employeenumber: '',
    fkrole: 0,
    fkbuilding: 0,
    fksite: 0,
    fksites: [],
    fkapproverarea: 0,
    fkemployeecreator: 0,
    employeecreatorname: '',
    creationdate: new Date(),
    strcreationdate: '',
    lastupdated: new Date(),
    strlastupdated: '',
    fkemployeeupdater: 0,
    employeeupdatername: '',
    email: '',
    available: false,
    usernameupdater: '',
    position: '',
    check: false,
    markCheckboxes: false,
    pksite: 0,
    pkbuildings: [],
    role: '',
    canedit: false,
  }
    loading = false;
    station: string = 'TABLE';
    columns: Array<any> = [
        'workdayid',
        'username',
        'employeename',
        'strcreationdate',
        'employeecreatorname',
        'strlastupdated',
        'employeeupdatername',
        'changestatuscolumnemployees',
        'canedit',
    ];
    displayedColumns: Array<string> = this.columns.map((c) => c.columnDef);
    constructor(
        private employeesService: EmployeesService,
        private notificationService: NotificationService,
        public translate: TranslateApplicationService,
        public dialog: MatDialog,
        private datePipe: DatePipe,
        private roleService: RolesService,
        public router: Router,
    ) {}

    ngOnInit() {
        this.loading = true;
        const component = this;
        jQuery('.btnReload').click(function () {
            component.GetEmployeesComponent();
        });
        this.GetEmployeesComponent();
    }

    GetEmployeesComponent() {
        this.loading = true;
        this.roleService.EmployeeHasPermissionToScreen('Users').subscribe(
            (result: TransactionResult<IScreens[]>) => {
                this.loading = false;
                if (result.success) {
                    if (result.data == null || result.data.length == 0)
                        this.router.navigateByUrl('/main/without-permission');
                }
                else{
                    this.ErrorMessage('ROLES.Error_employee_has_permission');
                    this.router.navigateByUrl('/main/without-permission');
                }
            },
            (error: any) => { this.ErrorAlert(error); this.loading = false; },
        );
        this.GetEmployees();
    }

    GetEmployees() {
        this.loading = true;
        this.employeesService.GetUsersBySite().subscribe(
            (result: TransactionResult<IEmployees[]>) => {
                this.loading = false;
                if (result.success) {
                    this.roleService.GetRoleByUser().subscribe(
                        (resultRol: TransactionResult<IRoles>) => {
                            if(resultRol){
                                this.listData = result.data;
                                this.listData.forEach((element) => {
                                    if(resultRol['role'].toLowerCase().trim() != "Administrator".toLowerCase().trim()){
                                        if(element.role.toLowerCase().trim() == "Administrator".toLowerCase().trim()){
                                            element.canedit = false;
                                        }
                                            
                                    }else{
                                        element.canedit = true;
                                    }                                  

                                    if (element.available == true) {
                                        element.check = true;
                                    } else {
                                        element.check = false;
                                    }
                                    element.strcreationdate = this.datePipe.transform(
                                        element.creationdate,
                                        'yyyy-MM-dd HH:mm:ss',
                                    );
                                    element.strlastupdated = this.datePipe.transform(
                                        element.lastupdated,
                                        'yyyy-MM-dd HH:mm:ss',
                                    );
                                    
                                });
                            }	
                        }
                    );
                }
                else{
                    this.ErrorAlert(result.message);
                }
            },
            (error: any) => { this.ErrorAlert(error); this.loading = false; },
        );
    }

    AddEmployee() {
        const dialogRef = this.dialog.open(EmployeesDetailComponent, {data: {}});
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                setTimeout(() => {
                this.GetEmployees();
                }, 1000);
            }
        });
    }

    EditEmployee(item: IEmployees) {
        item.markCheckboxes = true;
        const dialogRef = this.dialog.open(EmployeesDetailComponent, {
            data: item
        });
        dialogRef.afterClosed().subscribe( result => {
            if (result) {
                setTimeout(() => {
                    this.GetEmployees();
                }, 1000);
            }
        });
    }

    ViewEmployee(item: IEmployees) {
        item.markCheckboxes = true;
        const dialogRef = this.dialog.open(EmployeesDetailComponent, {
            data: item
        });
        dialogRef.afterClosed().subscribe( result => {
            if (result) {
                setTimeout(() => {
                    this.GetEmployees();
                }, 1000);
            }
        });
    }
    
    ChangeStatus(item: IEmployees) {
        this.loading = true;
        if(item.role.toLowerCase().trim() == "Administrator".toLowerCase().trim()){
            this.roleService.GetRoleByUser().subscribe(
                (result: TransactionResult<IRoles>) => {
                    if(result){
                        if(result['role'].toLowerCase().trim() == "Administrator".toLowerCase().trim()){
                            this.ChangeStatusEmployee(item);
                            this.loading = false;
                            this.GetEmployees();
                        }else{
                            this.ErrorAlert('No eres un Administrador');
                            this.loading = false;
                            this.GetEmployees();
                        }
                    }	
                }
            );
        }else{
            this.ChangeStatusEmployee(item);
            this.loading = false;
            this.GetEmployees();
        }
    }

    private ChangeStatusEmployee(item: IEmployees) {
        this.employeesService.ChangeEmployeeStatusBySite(item).subscribe(
            (result: TransactionResult<Boolean>) => {
                this.loading = false;
                if (result.success) {
                    this.Alert(
                        'Success',
                        this.translate.TranslateKey('COMPLETE'));
                    this.GetEmployees();
                }
                else {
                    this.Alert(
                        'Warning',
                        this.translate.TranslateKey('WARNING.Failed_updated_status'));
                }
            },
            (error: any) => { this.ErrorAlert(error); this.loading = false; });
    }

    Alert(title: string, message: string) {
        this.notificationService.AddAlert({
            icon: 'all_inbox',
            title: title,
            message: message,
            shown: true,
        });
    }

    ErrorAlert(message: any) {
        this.notificationService.AddAlert({
            icon: 'all_inbox',
            title: 'Error',
            message: message,
            shown: true,
        });
    }

    ErrorMessage(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: this.translate.TranslateKey(message),
			shown: true,
		});
	}
}